import {h, Component} from 'preact'
import classnames from 'classnames'

export default class Menu extends Component {
  onClickCategory (event, category) {
    event.preventDefault()
    this.props.onClick(category)
  }

  render ({categories, activeCategory}) {
    return (
      <ul class="list-inline">
        {categories.map((category, index) => {
          // very very bad code! please refactor
          return [0,1].map((i) => {
            if (i == 1) {
              if (index == categories.length - 1) return
              return <li class="list-inline-item"><span class="spacer"></span></li>
            }
            return (<li class={classnames({
              "list-inline-item": true,
              "font-weight-bold": activeCategory == category})}>
              <a href="#" onClick={(e) => this.onClickCategory(e, category)}>
                {category}
              </a>
            </li>)
          })
        })}
      </ul>
    )
  }
}
